import NavBar from "./NavBar";
import Footer from "./Footer";
import NewsTicker from "./NewsTicker";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <NewsTicker />
      <NavBar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
